export default __webpack_public_path__ + "static/media/boss_tartaglia_shard.1987ff67.png";